import { useEffect, useState } from "react";
const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";
/** Returns `true` when the user has enabled "Reduce motion" in their OS settings. */ export function useReducedMotion() {
    const [reducedMotion, setReducedMotion] = useState(()=>typeof window !== "undefined" && window.matchMedia(REDUCED_MOTION_QUERY).matches);
    useEffect(function subscribeToReducedMotionQuery() {
        const mediaQuery = window.matchMedia(REDUCED_MOTION_QUERY);
        const handleChange = (event)=>setReducedMotion(event.matches);
        mediaQuery.addEventListener("change", handleChange);
        return ()=>mediaQuery.removeEventListener("change", handleChange);
    }, []);
    return reducedMotion;
}

//# sourceMappingURL=useReducedMotion.js.map